<template>
  <section class="index">
    <global-header></global-header>
    <div class="banner">
      <template>
        <el-carousel :interval="5000" arrow="never"  style="height: 688px">
          <el-carousel-item
            v-for="item in slideBanner"
            :key="item.id"
            style="height: 688px"
          >
            <a :href="item.url" @click="isJumpLink" target="_blank"
              ><img :src="api+item['pic_url']" alt=""
            /></a>
          </el-carousel-item>
        </el-carousel>
      </template>
    </div>

    <main>
      <section class="main-top margin">
        <div class="business">
          <ul ref="busiul" style="width: 1250px; overflow: hidden">
            <li
              v-for="(ad, index) in adlist"
              :key="ad.id"
              :class="[index !== isActive ? litop : '']"
              @click="handlePath(index)"
              @mouseenter="handleadEnter(index)"
              @mouseleave="handleadLeave(index)"
              style="float: left; margin-right: 24px"
            >
              <div :class="[index === isActive ? activeClass : '', hoverdom]">
                <a href="javascript:;">
                  <h4>{{ ad.title }}</h4>
                  <div class="intro">
                    <div class="sldiv">{{ ad.content }}</div>
                  </div>
                </a>
              </div>

              <div class="normalDom">
                <a href="#">
                  <h4>{{ ad.title }}</h4>
                  <div class="intro">
                    <img :src="ad.img" />
                  </div>
                </a>
              </div>
            </li>
          </ul>
        </div>
        <div class="product">
          <div class="title">
            <h3>产品平台</h3>
            <p>通过对网上资源的整合与共享、业务的协作与联动，实行整合管理</p>
          </div>
          <ul class="pfbox" style="width: 1220px; overflow: hidden">
            <li
              v-for="(pf, index) in pflist"
              :key="pf.id"
              :class="{ producActive: index === isproductActive }"
              @mouseenter="handleproEnter(index)"
              @mouseleave="handleproLeave(index)"
              @click="handleClick(pf, index)"
              id="lunbo"
            >
              <a>
                <div class="pf-top">
                  <div class="imgbox">
                    <img :src="pf.img" />
                  </div>
                </div>
                <div class="pfname">{{ pf.name }}</div>
                <p class="pfcontent">{{ pf.content }}</p>
              </a>
            </li>
          </ul>
        </div>
      </section>
      <section class="main-bottom">
        <div class="news margin">
          <div class="title">
            <h3 style="padding-top: 32px">新闻资讯</h3>
            <p>请及时查看每天不一样的动态资讯</p>
          </div>
          <left_right_carousel :carouselData="carouselData" :interval="4000"></left_right_carousel>
        </div>
      </section>
    </main>
    <global-footer></global-footer>
  </section>
</template>

<script>
import GlobalFooter from "../components/g_footer";
import GlobalHeader from "../components/g_header";
import Img from "@/assets/img/main.jpg";
import { signCrypto } from "../utils/generateSecretKey";
import { dateFormat } from "../utils/index";
import VueImgSlider from "../components/VueImgSlider";
import left_right_carousel from "../components/left_right_carousel.vue";

export default {
  name: "Index",
  components: {
    GlobalFooter,
    GlobalHeader,
    Img,
    VueImgSlider,
    left_right_carousel
  },
  data() {
    return {
      // 轮播数据源 (可根据实际业务替换)
      carouselData: [],
      demoData: [
        {
          img:
            "https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=4114932100,812814281&fm=26&gp=0.jpg",
          title: "图片1",
        },
        {
          img:
            "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fpic.616pic.com%2Fbg_w1180%2F00%2F09%2F61%2FQzCxsD5wZf.jpg&refer=http%3A%2F%2Fpic.616pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1617420891&t=b8bcc97252327658f35bb052f871df56",
          title: "图片2",
        },
      ],
      items: [],
      show: true,
      activeClass: "show",
      litop: "litop",
      hoverdom: "hoverDom",
      isproductActive: true,
      isActive: "",
      input: "",
      newsimgList: [],
      adlist: [
        {
          id: 1,
          title: "智慧政务",
          img: require("../assets/img/ad1.png"),
          content: `以“服务型政府、法治政府、效能政府建设”为指导思想，
          依托“以公众为中心”理念，利用物联网、大数据、云计算等技术实现统一管理和服务创新，
          建设服务型电子政府，共同奏响城市和谐之歌。
                    `,
        },
        {
          id: 2,
          title: "智慧公安",
          img: require("../assets/img/ad2.png"),
          content: `通过推进应用系统整合、完善系统实战应用能力，
          实现警务信息“强度整合、高度共享、深度应用”的警务发展新理念新模式，
          形成集实战警务、民生警务、人文警务、规范警务为一体的智慧公安综合解决方案。`,
        },
        {
          id: 3,
          title: "智慧养老",
          img: require("../assets/img/ad4_03.jpg"),
          content: `以国家信息化战略为指引，树立“一盘棋”思想，
          加强顶层设计，统筹规划、整合资源，推进信息化与民政业务紧密融合，
          建立养老数据资源中心，为政府、组织、公众提供数据服务，辅助科学决策、精准养老服务。`,
        },
        {
          id: 4,
          title: "智慧检察院",
          img: require("../assets/img/ad3.png"),
          content: `基于移动互联网、大数据、云计算等技术，打造智慧党建平台，
          创新组织管理手段，提升党组织凝聚力，
          促进思想建设、组织建设、作风建设、制度建设和反腐倡廉建设“五位一体”的党建工作更加智慧化。`,
        },

        {
          id: 5,
          title: "智慧党建",
          img: require("../assets/img/ad5.png"),
          content: `以“改革创新、阳光检察、以人为本、方便群众”为建设理念，
          围绕服务百姓为中心，依托虚拟检察院做强实体检察院，
          打造阳光检察、便民检察、效能检察、满意检察的新模式`,
        },
      ],
      dynamicList: [],
      pflist: [],
      newslist: [],
      slideBanner: [],
      api: "https://www.fedtech.cc",
    };
  },
  created() {
    //产品平台
    this.getplatform();
    //新闻资讯
    this.getNews();
    this.setTitle();
    // 产品解决方案的下栏
    this.saveSideTit();
    this.getBanner();
  },
  mounted() {
    this.wordlimit("sldiv", 115); //"sldiv"添加多行省略号
    this.wordlimit("pfcontent", 102);
  },
  methods: {
    //判断a标签是否允许跳转
    isJumpLink(event){
      const url = event.target.href;
      const urlRegex = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;
      // 首先检查是否是有效的URL格式
      if (!urlRegex.test(url)) {
        event.preventDefault();
        return false;
      }
    },
    //轮播
    getBanner() {
      let that = this;
      this.$methods
        .http("/slide/achieve_category", "", "get")
        // .http("/slide/achieve_slide", params, "get")
        .then((res) => {
          if (res.data) {
            let params = {
              page: 1,
              pageSize: 10,
              cid: res.data["0"].id,
            };
            that.$methods
              .http("/slide/achieve_slide", params, "get")
              .then((ress) => {
                console.log(ress, "返回banner");
                that.slideBanner = ress.data;
              });
          }
        });
    },
    // 点击图片
    handleClickImg(v) {
      if (v.hasLink == "1") {
        window.open(v["link"], "_blank"); // 在新窗口打开外链接
      } else {
        this.$router.push({
          name: "newsDetail",
          params: {
            id: v.id,
            cid: v.cid,
          },
        });
      }
    },
    // 点击右侧的li
    handldClickPath(v) {
      if (v.hasLink == "1") {
        window.open(v["link"], "_blank");
      } else {
        this.$router.push({
          name: "newsDetail",
          params: {
            id: v.id,
            cid: v.cid,
          },
        });
      }
    },
    // 产品解决方案的下栏
    saveSideTit() {
      const data = {
        signField: [],
        pid: "",
      };
      const params = signCrypto(data);
      this.$methods
        .http("/news/achieve_news_category", params, "get")
        .then((res) => {
          this.saveClomn(res.data[1].id);
        });
    },
    /* 分类下的菜单 */
    saveClomn(pid) {
      const params = {
        pid,
      };
      /*   const params = signCrypto(data); */
      this.$methods
        .http("/news/achieve_news_category", params, "get")
        .then((res) => {
          /* this.list = res.data; */
          this.$EventBus.$emit("promenu", res.data);
          window.sessionStorage.setItem("promenu", JSON.stringify(res.data));
        });
    },

    handlePath(v) {
      this.$router.replace({ name: "design", query: { val: v } });
    },
    // 跳转新闻页面
    handleClickTo() {
      let id = JSON.parse(sessionStorage.getItem("listTit"))[3].id;
      this.$router.replace({ name: "news", query: { id } });
    },
    setTitle() {
      const data = {
        signField: [],
        pid: "",
        is_menu: 2,
      };
      const params = signCrypto(data);
      this.$methods
        .http("/news/achieve_news_category", params, "get")
        .then((res) => {
          if (res.data[0].type === "0") {
            // 分类
            this.$EventBus.$emit("resData", res.data);
            window.sessionStorage.setItem("listTit", JSON.stringify(res.data));
          }
        });
    },
    handleClick(pf, index) {
      this.$router.push({ path: "/column", query: { id: pf.id, val: index } });
    },
    handleadEnter(index) {
      this.isActive = index;
    },
    handleadLeave() {
      this.isActive = "";
    },
    handleproEnter(index) {
      this.isproductActive = index;
    },
    handleproLeave() {
      this.isproductActive = "";
    },
    getplatform() {
      let params = {
        page: 1,
        pageSize: 12,
        cid: "416220272903852032",
        title: "",
        has_pic: "",
      };
      this.$methods
        .http("/news/achieve_news_by_cid", params, "get")
        .then((res) => {
          res.data.forEach((item) => {
            this.pflist.push({
              name: item.title,
              img: item.pic_url,
              content: item.resume,
              id: item.id,
            });
          });
        });
    },
    getNews() {
      let params = {
        page: 1,
        pageSize: 3,
        cid: "416240870006722560",
        title: "",
        has_pic: "",
      };
      this.$methods
        .http("/news/achieve_news_by_cid", params, "get")
        .then((res) => {
          this.carouselData = res.data.map(item => {
            return {
              imgUrl: item.pic_url, // 示例图片
              hasLink: item.is_outsite_link,
              link: item.link_url,
              title: item.title,
              desc: item.resume,
              date: {
                year: dateFormat('YYYY', item.create_time),
                monthDay: dateFormat('MM-DD', item.create_time),
              },
            };
          })
        });
    },
    wordlimit(cname, wordlength) {
      //多行省略号
      var cname = document.getElementsByClassName(cname);
      for (var i = 0; i < cname.length; i++) {
        var nowhtml = cname[i].innerHTML;
        var nowlength = cname[i].innerHTML.length;
        if (nowlength > wordlength) {
          cname[i].innerHTML = nowhtml.substr(0, wordlength) + "……";
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="stylus" >

/* 新闻左侧菜单 */
.sideLi {
}

#lunbo {
  float: left;
  margin-right: 20px;

  &:nth-child(5), &:nth-child(6), &:nth-child(7), &:nth-child(8) {
    margin-top: 20px;
  }

  p {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 7;
    overflow: hidden;
  }
}

.banner {
  margin-top: 90px !important;
  height: 688px;
  .el-carousel__indicator{
    margin-bottom:80px
  }
  // height: 710px;
  img {
    display: block;
    width: 100%;
    /* height: 100%; */
    height: 688px;
  }
}

.title {
  text-align: center;
  margin: 35px 0;

  h3 {
    font-size: 36px;
    line-height: 72px;
    color: #000000;
  }

  p {
    color: #99999b;
    font-size: 14px;
    line-height: 28px;
  }
}

.common1 {
  opacity: 1;
  -ms-transform: scaleY(1);
  transform: scaleY(1);
  // transition: transform 0.5s cubic-bezier(0.23, 1, 0.32, 1) 0.1s, opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1) 0.1s;
  -ms-transform-origin: center top;
  transform-origin: center top;
}

main {
  background: #f4f4f4;

  .main-top {
    .business {
      position: relative;
      top: -75px;
      z-index: 10;

      ul {
        display: flex;
        justify-content: space-around;

        li {
          width: 220px;
          border-bottom: 1px solid #e5e5e5;
          background: #fff;
          position: relative;

          .pull-up-enter-active, .pull-up-leave-active {
            @extend .common1;
            transform-origin: center bottom;
          }

          .pull-up-enter, .pull-up-leave-active, .drop-down-enter, .drop-down-leave-active {
            opacity: 0;
            -ms-transform: scaleY(0);
            transform: scaleY(0);
          }

          .hoverDom {
            /* display: none; */
            height: 306px;
            position: absolute;
            z-index: 9;
            top: -365px;
            background-color: rgba(190, 30, 26, 0.5);
            background: url('../assets/img/main6.png') no-repeat center;
            background-size: 100% 100%;
            width: 220px;
            left: 0;
            transition: all 1100ms;
            -webkit-transition: all 1100ms;
            -moz-transition: all 1100ms;
            -o-transition: all 1100ms;
            overflow: hidden;

            a {
              color: #fff;

              h4 {
                border-bottom: 1px solid #c84845;
                color: #fff;
              }

              .intro {
                .sldiv {
                  font-size: 12px;
                  line-height: 24px;
                  overflow: hidden;
                }
              }
            }
          }

          .show {
            display: block;
            top: 0;
            overflow: hidden;
            z-index: 9;
            width: 220px;
            // animation: name  5s  linear  2s  infinite alternate;
          }

          a {
            display: block;
            width: 100%;

            h4 {
              font-weight: 600;
              font-size: 24px;
              line-height: 68px;
              text-align: center;
              margin-top: 6px;
              color: #000;
              border-bottom: 1px solid #e5e5e5;
            }

            .intro {
              padding: 19px;
              height: 229px;

              img {
                display: block;
                width: 100%;
                height: 100%;
              }
            }
          }
        }

        .litop {
          /* margin-top: 30px; */
          display: block;
          width: 220px;
          height: 306px;
        }
      }
    }

    .product {
      margin-top: -60px;

      .pfbox {
        display: flex;
        justify-content: left; /*space-around;*/
        flex-wrap: wrap;

        .producActive {
          background-color: rgba(190, 30, 26, 0.5);
          background: url('../assets/img/main7.png') no-repeat center;
          background-size: 100% 100%;
          color: #fff;

          p {
            color: #e1a8a8;
          }
        }

        li {
          width: 284px;
          background: #fff;
          padding: 20px 30px 20px;
          margin: 0 10px 10px 0;

          a {
            display: block;

            .pf-top {
              margin: 0 72px;

              .imgbox {
                width: 82px;
                height: 82px;
                border: 1px solid #ececec;
                border-radius: 41px;
                background: #f9f9f9;
                text-align: center;
                line-height: 108px;
              }
            }

            .pfname {
              font-weight: 500;
              font-size: 16px;
              line-height: 48px;
              text-align: center;
            }

            p {
              position: relative;
              color: #999;
              font-size: 12px;
              line-height: 24px;
              letter-spacing: 1px;
              margin-bottom: 30px;
            }
          }
        }
      }
    }
  }

  .el-carousel__container {
    height: 360px;
    overflow: hidden;
  }

  .main-bottom {
    background: #fff;
    padding-bottom: 40px;

    .content-box {
      height: 404px;
      display: flex;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue